// redex/reportLists/userActions.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import {  testingListsApi } from "./testingApi";
import { showApiErrorToast } from "../../utils/toastErrorHandler";

/* The session ends on 401 and only on 401 — a request that failed is not a
   token that expired. Clearing on any error signed the whole app out over a
   500 or a refused form, and left the header reading a key that was no longer
   there. Same guard as taskActions.js. */
const endSessionIfUnauthorized = (err) => {
  if (err?.response?.status !== 401) return;
  localStorage.removeItem("token");
  localStorage.removeItem("user");
};

export const testingListsApis = createAsyncThunk(
  "testingListsApi/testingListsApi",
  async (payload, { rejectWithValue }) => {
    try {
      return await testingListsApi(payload);
    } catch (err) {
      endSessionIfUnauthorized(err);

      showApiErrorToast(err?.response?.data?.error || err.message);

      return rejectWithValue(err?.response?.data?.message || err.message);
    }
  },
);
